// macadamia-app/src/macadamia-core/components/SortableBlock.tsx
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { DragHandleProvider } from './DragHandleContext';

interface SortableBlockProps {
    id: string;
    sectionIndex: number;
    blockIndex: number;
    block: any; // Using any to avoid circular dependencies for now, or could import IBlock
    children: React.ReactNode;
}

export const SortableBlock: React.FC<SortableBlockProps> = ({
    id,
    sectionIndex,
    blockIndex,
    block,
    children
}) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({
        id,
        data: {
            sectionIndex,
            blockIndex,
            block // Pass the full block object here
        }
    });

    const style = {
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        transition,
        opacity: isDragging ? 0.5 : 1,
        pointerEvents: 'auto' as const
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            data-block-id={id}
        >
            <DragHandleProvider listeners={listeners} attributes={attributes}>
                {children}
            </DragHandleProvider>
        </div>
    );
};
